import axios from './axios'

// Get TBT signings for the current subcontractor
export const getTBTSignings = (params = {}) => {
  return axios.get('tbt-signings', { params })
}

// Get specific TBT signing details
export const getTBTSigning = (id) => {
  return axios.get(`tbt-signings/${id}`)
}

// Submit signature for TBT
export const submitTBTSignature = (id, signatureData) => {
  return axios.post(`tbt-signings/${id}/sign`, signatureData)
}

// Get PDF download URL for signed TBT
export const getTBTPdfDownload = (id) => {
  return axios.get(`tbt-signings/${id}/download`)
}
